class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);
    if (event.target.type === 'number' || !this.currentVariant) {
      return;
    }

    this.updateMedia();
    this.updateURL();

    document.dispatchEvent(
      new CustomEvent('sku:update', {
        detail: { sku: this.currentVariant.sku },
      }),
    );

    fetch(window.location.href + '&sections=main-product')
      .then((response) => response.json())
      .then((sections) => {
        const html = new DOMParser().parseFromString(
          sections['main-product'],
          'text/html',
        );

        const elementsToReplace = document.querySelectorAll('[js-replace]');
        elementsToReplace.forEach((element) => {
          const replaceValue = element.getAttribute('js-replace');
          const newElement = html.querySelector(
            `[js-replace="${replaceValue}"]`,
          );
          if (newElement) {
            element.replaceWith(newElement);
          }
        });
      })
      .catch((err) => console.log(err));
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    // const productMedia = document.querySelector('product-media');
    // productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
